import { clone, feature, featureCollection, getCoords, lineString, polygon } from '@turf/turf';
import { operation } from 'jsts';
import { LatLng, LatLngBounds } from 'leaflet';
import { gpx } from 'leaflet-omnivore';
import { toGeoJSON, toJstsGeometry } from './jsts';
import isEqual from 'lodash/isEqual';
export const findBbox = ({ firstCornerY, firstCornerX, secondCornerY, secondCornerX }) => {
    const corner1 = new LatLng(firstCornerY, firstCornerX);
    const corner2 = new LatLng(secondCornerY, secondCornerX);
    return new LatLngBounds(corner1, corner2);
};
export const wholeWorldBounds = findBbox({
    firstCornerX: -160,
    firstCornerY: -90,
    secondCornerX: 200,
    secondCornerY: 90,
});
export const multiPolygonToPolygon = (geoJSON, properties = {}) => {
    if (geoJSON.type === 'MultiPolygon') {
        return geoJSON.coordinates.map((coord) => {
            return polygon(coord, properties);
        });
    }
    else if (geoJSON.type.match(/(Feature)|(FeatureCollection)/)) {
        return multiPolygonToPolygon(geoJSON.geometry, properties);
    }
    return [polygon(geoJSON.coordinates, properties)];
};
export const multiLineStringToLineString = (geoJSON, properties = {}) => {
    if (geoJSON.type === 'MultiLineString') {
        return geoJSON.coordinates.map((coord) => {
            return lineString(coord, properties);
        });
    }
    else if (geoJSON.type.match(/(Feature)|(FeatureCollection)/)) {
        return multiLineStringToLineString(geoJSON.geometry, properties);
    }
    return [lineString(geoJSON.coordinates, properties)];
};
export const gpxToGeoJSON = (gpxString) => gpx.parse(gpxString).toGeoJSON();
export const polygonSlice = (poly, splitter) => {
    if (!splitter) {
        return featureCollection([poly]);
    }
    let polyJsts = toJstsGeometry(poly);
    const splitterJsts = toJstsGeometry(splitter);
    const { geometry: { coordinates: splitterCoordinates }, } = splitter;
    if (polyJsts.getNumInteriorRing() !== 0 && !isEqual(splitterCoordinates[0], splitterCoordinates.slice(-1).pop())) {
        const lineCoordinates = splitterJsts.getCoordinates().map((coordinates) => [coordinates.x, coordinates.y]);
        const polygonCoordinates = [...lineCoordinates].reverse();
        lineCoordinates.forEach((coordinates) => {
            polygonCoordinates.push([coordinates[0] + 0.000001, coordinates[1]]);
        });
        polygonCoordinates.push(polygonCoordinates[0]);
        const linePolygon = polygon([polygonCoordinates]);
        const linePolygonJsts = toJstsGeometry(linePolygon);
        try {
            polyJsts = polyJsts.difference(linePolygonJsts);
        }
        catch (ignored) {
        }
    }
    const polygonizer = new operation.polygonize.Polygonizer();
    polygonizer.add(polyJsts.getBoundary().union(splitterJsts));
    const polygons = polygonizer.getPolygons();
    const innerPolygons = [];
    for (const i = polygons.iterator(); i.hasNext();) {
        const p = i.next();
        if (polyJsts.contains(p.buffer(-0.00001))) {
            innerPolygons.push(feature(toGeoJSON(p)));
        }
    }
    return featureCollection(innerPolygons);
};
export const exteriorPolygon = (poly) => {
    return polygon([getCoords(poly)[0]]);
};
export const lineStretch = (line, delta) => {
    const coords = getCoords(clone(line));
    if (coords.length < 2) {
        return line;
    }
    if (coords.length === 2) {
        const stretch = computeLineExtension(coords[0], coords[coords.length - 1], delta);
        coords[0] = stretch[0];
        coords[coords.length - 1] = stretch[1];
    }
    else {
        const stretch1 = computeLineExtension(coords[0], coords[1], delta);
        const stretch2 = computeLineExtension(coords[coords.length - 1], coords[coords.length - 2], delta);
        coords[0] = stretch1[0];
        coords[coords.length - 1] = stretch2[0];
    }
    return lineString(coords);
};
const computeLineExtension = (startCoords, endCoords, delta) => {
    const th = delta;
    const l1 = 0.0 - th;
    const l0 = 1.0 + th;
    const p1ExtX = l0 * startCoords[0] + (1 - l0) * endCoords[0];
    const p1ExtY = l0 * startCoords[1] + (1 - l0) * endCoords[1];
    const p2ExtX = l1 * startCoords[0] + (1 - l1) * endCoords[0];
    const p2ExtY = l1 * startCoords[1] + (1 - l1) * endCoords[1];
    const p1Ext = [p1ExtX, p1ExtY];
    const p2Ext = [p2ExtX, p2ExtY];
    return [p1Ext, p2Ext];
};
//# sourceMappingURL=map.js.map